// client/src/services/paymentUploadService.js
import api from './api';

const paymentUploadService = {
  getPaymentUploads: async () => {
    const response = await api.get('/payment-uploads');
    return response.data;
  },
  
  getPaymentUpload: async (id) => {
    const response = await api.get(`/payment-uploads/${id}`);
    return response.data;
  },
  
  uploadPaymentFile: async (formData) => {
    const response = await api.post('/payment-uploads', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },
  
  deletePaymentUpload: async (id) => {
    const response = await api.delete(`/payment-uploads/${id}`);
    return response.data;
  },
  
  downloadPaymentTemplate: async (receiptId) => {
    // Trigger download by creating a temporary link
    try {
      const response = await api.get(`/payment-uploads/template/${receiptId}`, {
        responseType: 'blob'
      });
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `payment_template_${receiptId}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      return true;
    } catch (error) {
      console.error('Download error:', error);
      throw error;
    }
  }
};

export default paymentUploadService;